// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/styles/base.css */
:root {
  --green: #7ED321;
  --blue: #2C3E50;
  --bg: #F5F8FB;
  --primary: #1fd286;
  --text-dark: #0f172a;
  --text-muted: #475569;
  --border-light: #e5e7eb;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Inter', sans-serif;
}

body {
  background: var(--bg);
  color: var(--blue);
  overflow-x: hidden;
}

/* Shared utility classes (used across pages) */
.eyebrow {
  display: inline-block;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: var(--green);
  margin-bottom: 16px;
}

/* Reveal Animation (used everywhere) */
.reveal {
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}
.reveal.visible {
  opacity: 1;
  transform: translateY(0);
}`, "",{"version":3,"sources":["webpack://./src/styles/base.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,+CAA+C;AAC/C;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,UAAU;EACV,2BAA2B;EAC3B,kDAAkD;AACpD;AACA;EACE,UAAU;EACV,wBAAwB;AAC1B","sourcesContent":["/* src/styles/base.css */\n:root {\n  --green: #7ED321;\n  --blue: #2C3E50;\n  --bg: #F5F8FB;\n  --primary: #1fd286;\n  --text-dark: #0f172a;\n  --text-muted: #475569;\n  --border-light: #e5e7eb;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: 'Inter', sans-serif;\n}\n\nbody {\n  background: var(--bg);\n  color: var(--blue);\n  overflow-x: hidden;\n}\n\n/* Shared utility classes (used across pages) */\n.eyebrow {\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 700;\n  letter-spacing: 0.15em;\n  text-transform: uppercase;\n  color: var(--green);\n  margin-bottom: 16px;\n}\n\n/* Reveal Animation (used everywhere) */\n.reveal {\n  opacity: 0;\n  transform: translateY(40px);\n  transition: opacity 0.8s ease, transform 0.8s ease;\n}\n.reveal.visible {\n  opacity: 1;\n  transform: translateY(0);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
